// src/components/maestros/forms/FormModalCreateTransportadora.jsx
import React, { useEffect, useState } from 'react'
import { MDBRow, MDBCol, MDBBtn } from 'mdb-react-ui-kit'
import Swal from 'sweetalert2'
import '../../../Pages/Css/modalesMaestros.css'
import axios from '../../../utils/axiosConfig'

const FormModalCreateTransportadora = ({ onSave, initialData }) => {
    const [nombre, setNombre] = useState('')
    const [alias, setAlias] = useState('')
    const [proyectoId, setProyectoId] = useState('')

    const [proyectos, setProyectos] = useState([]);

    const submit = e => {
        e.preventDefault()
        if (!nombre.trim() || !alias.trim() || !proyectoId.trim()) {
            Swal.fire('Error', 'Debe completar Nombre, Alias y Proyecto', 'error')
            return
        }
        console.log('Transportadora creada:', { nombre, alias, proyectoId })
        onSave({ nombre, alias, proyectoId: parseInt(proyectoId) })
    }

    const validateStringLength = (tipo, str, maxLength) => {
        if (str.length >= maxLength) {
            Swal.fire('Error', `El ${tipo} no puede exceder ${maxLength} caracteres`, 'error');
            return false;
        }
        return true;
    };

    const getProyectos = () => {
        // Lógica para obtener proyectos
        axios.get(`${process.env.REACT_APP_SERVER}/operaciones/getproyectos`, {}, {
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('tkn')}` },
            withCredentials: true
        })
            .then(res => {
                if (res.data.success) {
                    console.log('Proyectos obtenidos:', res.data.data);
                    setProyectos(res.data.data);

                } else {
                    Swal.fire('Error', 'No se pudieron obtener proyectos', 'error');
                }
            })
            .catch(() => {
                Swal.fire('Error', 'Falla de red al obtener proyectos', 'error');
            });
    }

    useEffect(() => {
        getProyectos();
    }, []);

    useEffect(() => {
        if (initialData) {
            console.log('Cargando datos iniciales:', initialData);
            setNombre(initialData.nombre || '');
            setAlias(initialData.alias || '');
        }
    }, [initialData]);

    // Cuando ya hay proyectos y initialData, entonces setea el proyectoId
    useEffect(() => {
        if (initialData && proyectos.length > 0) {
            const idInicial = initialData.proyectoId || null;
            console.log('ID inicial:', idInicial);
            if (idInicial) {
                const match = proyectos.find(p => p.IDProyecto === parseInt(idInicial));
                if (match) {
                    console.log('Proyecto inicial encontrado:', match);
                    setProyectoId(String(match.IDProyecto)); // siempre como string en el select
                }
            }
        }
    }, [proyectos, initialData]);



    return (
        <>
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Nombre</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Nombre de la transportadora"
                        value={nombre}
                        maxLength={50} // aquí siempre va un número
                        onChange={e => {
                            const value = e.target.value
                            if (validateStringLength('Nombre', value, 50)) {
                                setNombre(value)
                            }
                        }}
                        style={{ boxSizing: 'border-box' }}
                    />
                </MDBCol>
            </MDBRow>

            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Alias</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Alias de la transportadora"
                        value={alias}
                        maxLength={10}
                        onChange={e => {
                            const value = e.target.value
                            if (validateStringLength('Alias', value, 10)) {
                                setAlias(value)
                            }
                        }}
                        style={{ boxSizing: 'border-box' }}
                    />
                </MDBCol>
            </MDBRow>

            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Proyecto</label>
                    <select
                        className="form-control"
                        value={proyectoId}
                        onChange={e => setProyectoId(e.target.value)}
                        style={{ boxSizing: 'border-box' }}
                    >
                        <option value="">Selecciona un proyecto</option>
                        {proyectos.map(p => (
                            <option key={p.IDProyecto} value={p.IDProyecto}>
                                {p.Descripcion}
                            </option>
                        ))}
                    </select>
                </MDBCol>
            </MDBRow>

            <div className="d-flex justify-content-end">
                <button className='btn-primary-modals-maestros' onClick={submit}>
                    Guardar
                </button>
            </div>
        </>
    )
}

export default FormModalCreateTransportadora
